import BlogInnerAccor from "../BlogInnerAccor";
import BlogSec1Availability from "../BlogSec1Availability";
import "./BlogInnerSec1.css";
import { Row, Col } from "react-bootstrap";

export const BlogInnerSec1 = ({ blog }) => {
  return (
    <>
      <div className="standard-padding">
        <div className={`my-3 packageDetailsTab`}>
          {/* ================= DESKTOP VIEW (UNTOUCHED) ================= */}
          <Row className="d-none d-lg-flex">
            <Col md={12} lg={8}>
              <BlogInnerAccor blog={blog} />
            </Col>

            <Col md={12} lg={4} className="paddingLeftFrSpace">
              <BlogSec1Availability blog={blog} />
            </Col>
          </Row>

          {/* ================= MOBILE VIEW ================= */}
          <Row className="d-block d-lg-none">
            {/* 1. Table of Content at top */}
            <Col xs={12}>
              <BlogSec1Availability blog={blog} showOnly="toc" />
            </Col>

            {/* 2. Blog Main Article in middle */}
            <Col xs={12} className="my-3">
              <BlogInnerAccor blog={blog} />
            </Col>

            {/* 3. Recent Posts at bottom */}
            <Col xs={12}>
              <BlogSec1Availability blog={blog} showOnly="recentPosts" />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};